import { Dispatch, SetStateAction, useState } from "react";
import { GridApi } from "ag-grid-community";
import { Modal } from "antd";
import AlertsGrid from "@pages/performance-overview/overview/alerts-module/AlertsGrid";
import ActiveRulesGrid from "@pages/performance-overview/overview/active-rules-module/ActiveRulesGrid";
import RulesSelectFilter from "@pages/performance-overview/overview/active-rules-module/RulesSelectFilter";
import { AiOutlineClose } from "react-icons/ai";

interface IExpand {
    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
    modalTitle: string;
}
const ExpandModal: React.FC<IExpand> = ({ show, setShow, modalTitle }) => {
    const handleClose = () => {
        setShow(false);
    };
    const [gridApi, setGridApi] = useState<GridApi>();

    return (
        <>
            {show && (
                <Modal
                    open={show}
                    onCancel={handleClose}
                    width="95%"
                    style={{ top: 20, height: "95vh" }}
                    styles={{ body: { height: "85vh", overflowY: "auto" } }}
                    closeIcon={<AiOutlineClose style={{ fontSize: "35px" }} />}
                    title={
                        <div className="d-flex align-items-center pb-3">
                            {modalTitle}
                            {modalTitle === "Alerts" ? null : (
                                <RulesSelectFilter gridApi={gridApi} />
                            )}
                        </div>
                    }
                    footer={null}
                >
                    <div>
                        {modalTitle === "Alerts" ? (
                            <AlertsGrid />
                        ) : (
                            <ActiveRulesGrid setGridApi={setGridApi} />
                        )}
                    </div>
                </Modal>
            )}
        </>
    );
};

export default ExpandModal;
